export default __webpack_public_path__ + "static/media/home.fd0250d7.svg";